import React from "react";
export const Section = ({ children }) => {
  return (
    <h2 className="font-sans text-light-grey-1 uppercase flex items-center tracking-widest mb-10">
      <span className="inline-block border-t border-light-grey-2 w-5 md:w-10 lg:w-30 mr-5"></span>{" "}
      {children}
    </h2>
  )
}
